import request from '@/utils/request'
export function getAllMessages() {
  return request({
    url: '/notification/getallmessages',
    method: 'post'
  })
}

export function getAllMessagesV2(type_id) {
  return request({
    url: '/notification/getallmessagesv2',
    method: 'post',
    data: { type_id: type_id }
  })
}

export function setMessageAsRead(id) {
  return request({
    url: '/notification/setasread',
    method: 'post',
    data: { id: id }
  })
}
export function setNotificationId(notifId) {
  return request({
    url: '/notification/setplayerid',
    method: 'post',
    data: { playerid: notifId }
  })
}
export function removeNotificationId(notifId) {
  return request({
    url: '/notification/removeplayerid',
    method: 'post',
    data: { playerid: notifId }

  })
}




